import { Card, Grid, makeStyles, Tab, Tabs } from "@material-ui/core";
import React, { useState } from "react";
import { ListProps } from "react-admin";
import CardContent from "@material-ui/core/CardContent";
import SanitizedGrid from "../../components/SanitizedGrid";
import TabPanel from "../routeplans/components/TabPanel";
import SubcontractorErpTable from "./components/SubcontractorErpTable";
import HeaderContent from "../../components/layout/components/HeaderContent";

const useStyles = makeStyles({
  sidePanelTabs: {
    borderBottom: "1px solid #C4C4C4",
    "& .MuiTabs-fixed > .MuiTabs-indicator": {
      backgroundColor: "#989898 !important",
      height: "3px !important",
    },
  },
});

const SubcontractorErpList = (props: ListProps) => {
  const [valueErpListTab, setValueErpListTab] = useState(0);
  const classes = useStyles();

  const handleChangeErpListTab = (
    _event: React.ChangeEvent<{}>,
    newValue: number,
  ) => {
    setValueErpListTab(newValue);
  };
  const erpListProps = (index: number) => {
    return {
      id: `erpList-tab-${index}`,
      "aria-controls": `erpList-tabpanel-${index}`,
    };
  };

  const breadcrumb = [
    { link: "/subcontractorErps", title: "Subcontractor ERP Charges" },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Subcontractor ERP Charges"
        isNotHaveSchoolFilter
      />

      <Card>
        <CardContent>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Tabs
                value={valueErpListTab}
                onChange={handleChangeErpListTab}
                aria-label="Subcontractor ERP List"
                className={classes.sidePanelTabs}
              >
                <Tab label="Unissued ERP Charges" {...erpListProps(0)} />
                <Tab label="Issued ERP Charges" {...erpListProps(1)} />
              </Tabs>

              <TabPanel value={valueErpListTab} index={0}>
                <Grid item xs={12}>
                  <SubcontractorErpTable
                    hasIssued={false}
                    isFilterByPeriod
                    isShowTitle
                    isFixedHeight
                  />
                </Grid>
              </TabPanel>

              <TabPanel value={valueErpListTab} index={1}>
                <Grid item xs={12}>
                  <SubcontractorErpTable
                    hasIssued={true}
                    isFilterByPeriod
                    isShowTitle
                    isFixedHeight
                  />
                </Grid>
              </TabPanel>
            </Grid>
          </SanitizedGrid>
        </CardContent>
      </Card>
    </>
  );
};

export default SubcontractorErpList;
